import { ButtonView } from '@vivli/shared/views';
import { CSSProperties, useState } from 'react';
import { useModalApiContext } from '@vivli/core/infrastructure/context';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

export interface ConfirmButtonViewProps {
    title?: string;
    children?: any;
    confirmMessage?: string;
    apiCall?: () => Observable<any>;
    callback?: (confirmed: boolean, apiResult?: any) => void;
    callbackError?: (apiResult?: any) => void;
}

const buttonStyle: CSSProperties = {
    margin: 'auto',
    height: 34,
    fontSize: 13,
    paddingLeft: 10,
    paddingRight: 10,
    minWidth: 87,
};

export const ConfirmButtonView = ({ title, confirmMessage, apiCall, callback, callbackError, children }: ConfirmButtonViewProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const modalService = useModalApiContext();

    const showConfirmModal = () => {
        modalService.confirm(confirmMessage, {
            onConfirm: () => {
                if (apiCall) {
                    setIsLoading(true);
                    apiCall()
                        .pipe(finalize(() => setIsLoading(false)))
                        .subscribe(
                            (apiResult) => {
                                callback && callback(true, apiResult);
                            },
                            (error) => callbackError && callbackError(error)
                        );
                } else {
                    callback && callback(true);
                }
            },
        });
    };

    return (
        <ButtonView
            theme={'white-on-red'}
            isLoading={isLoading}
            disabled={isLoading}
            title={title}
            style={buttonStyle}
            onClick={showConfirmModal}
        >
            {children}
        </ButtonView>
    );
};
